<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     状态选择器
  +---------------------------------------------------------------------------------------
-->
<template>
  <vxe-pulldown ref="managerDown" class="common-status-selector" :transfer="transfer" :disabled="disabled">
    <template #default>
      <div class="flex" role="button" @click="togglePanel">
        <div class="bd">
          <span v-if="status == 50" class="common-tag level-2">进行中</span>
          <span v-else-if="status == 100" class="common-tag level-3">已完成</span>
          <span v-else-if="status == 0" class="common-tag level-1">打开</span>
          <span v-else-if="status == -1" class="common-tag level-4">已关闭</span>
        </div>
        <div class="ft flex-center">
          <i v-if="!showDown" class="el-icon-arrow-down arrow-show" />
          <i v-else class="el-icon-arrow-up arrow-show" />
        </div>
      </div>

    </template>
    <template #dropdown>
      <div class="my-dropdown3">
        <div v-for="item in list" :key="'level'+item.value" class="flex pl-sm pr-sm down-item"
          :class="status==item.value&&'text-muted'" @click="handleChange(item.value)">
          <div class="bd flex align-items-center">
            <span>{{item.label}}</span>
          </div>
          <div v-if="status==item.value" class="ft flex-center">
            <i class="el-icon-check text-primary"></i>
          </div>
        </div>
      </div>
    </template>
  </vxe-pulldown>
</template>

<script>
export default {
  name: 'CommonStatusSelector',

  props: {
    value: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'medium'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enabled: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      showDown: false,
      list: [
        {
          label: '打开',
          value: 0
        },
        {
          label: '进行中',
          value: 50
        },
        {
          label: '已完成',
          value: 100
        },
        {
          label: '关闭',
          value: -1
        },
      ]
    }
  },

  computed: {
    status: {
      get () {
        return this.value || this.value == 0 ? this.value : null
      },
      set (val) {
        return val
      }
    }
  },
  mounted () {
    if (!this.enabled)
      this.togglePanel()
  },
  methods: {
    handleChange (val) {
      // this.status = val
      this.togglePanel()
      this.$emit('change', val)
    },

    handleVisibleChange (e) {
      !e && this.$emit('change')
    },
    async togglePanel () {
      await this.$refs.managerDown.togglePanel()
      this.showDown = await this.$refs.managerDown.isPanelVisible()
    }
  }
}
</script>

<style lang="scss" scoped>
.common-status-selector {
  width: 100%;
}
</style>
